import { render, staticRenderFns } from "./ActualIssues.vue?vue&type=template&id=231f4744&scoped=true&"
import script from "./ActualIssues.vue?vue&type=script&lang=ts&"
export * from "./ActualIssues.vue?vue&type=script&lang=ts&"
import style0 from "./ActualIssues.vue?vue&type=style&index=0&id=231f4744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f4744",
  null
  
)

export default component.exports